<template>
  <div class="PlatformDocumentsView">
    <section class="PlatformDocumentsView__documents-section">
      <DocumentsList :documents-list="documentsList" />
    </section>
  </div>
</template>

<script>
import DocumentsList from '../components/Documents/DocumentsList/index.vue';

export default {
  name: 'PlatformDocuments',
  components: {
    DocumentsList,
  },

  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    documentsList() {
      return this.$store.getters['documents/list'];
    },

    contractsList() {
      return this.documentsList.filter((document) => document.documents_types.type === 'contract');
    },

    invoicesList() {
      return this.documentsList.filter((document) => document.documents_types.type === 'invoice');
    },
  },

  methods: {
    async getData() {
      this.isLoading = true;
      await this.$store.dispatch('documents/getList');
      this.isLoading = false;
    },
  },

  created() {
    this.getData();
  },
};
</script>

<style lang="sass" scoped>

.PlatformDocumentsView
  height: 100%
  width: 100%
  display: flex
  background: #FDFEFE
  margin-bottom: 2rem

  &__documents-section
    height: 100%
    width: 100%
    display: flex
    flex-direction: column
    justify-content: flex-start
</style>
